export enum Seeking {
	Men = 'men',
	Women = 'women',
}
